import { detectStandalone } from "@/hooks/pwa/useIsPwa";
import { getPlatform, getServeConfig, getTheme } from "@/stores/useEnvConfigStore";
import { compare } from "compare-versions";
import { UAParser } from "ua-parser-js";

function initBrowserAttribute() {
  const browser = window.parsedUserAgent.browser.name?.toLowerCase();
  const isChrome = browser?.includes("chrome");
  const isSafari = browser?.includes("safari");
  const version = window.parsedUserAgent.browser.version || "0";

  const chromeVersion = isChrome && version;

  const isLowChrome = isChrome && compare(version, "128", "<");
  const isLowSafari = isSafari && compare(version, "16.8", "<");
  const bellowBrowser = isLowChrome || isLowSafari;

  document.documentElement.setAttribute("data-bellow-browser", bellowBrowser ? "true" : "false");
  document.documentElement.setAttribute("data-chrome-version", chromeVersion || "0");
}

function initWebviewAttribute() {
  if (window.__WEBVIEW_CONFIG__) {
    console.log("__WEBVIEW_CONFIG__", window.__WEBVIEW_CONFIG__);
    const { safeArea } = window.__WEBVIEW_CONFIG__;
    document.documentElement.style.setProperty("--safe-area-inset-right", `${safeArea.right}px`);
    document.documentElement.style.setProperty("--safe-area-inset-bottom", `${safeArea.bottom}px`);
    document.documentElement.style.setProperty("--safe-area-inset-left", `${safeArea.left}px`);
    document.documentElement.style.setProperty("--safe-area-inset-top", `${safeArea.top}px`);
  }
}

export function initAttribute() {
  const theme = getTheme();
  const platform = getPlatform();
  const { area } = getServeConfig();
  const ua = navigator.userAgent || "";
  const uaParser = UAParser(ua);
  const isStandalone = detectStandalone();

  window.parsedUserAgent = uaParser;
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.setAttribute("data-area", area);
  document.documentElement.setAttribute("data-platform", platform);
  document.documentElement.setAttribute("data-standalone", isStandalone ? "true" : "false");

  initBrowserAttribute();
  initWebviewAttribute();
}
